var MyClass = function MyClass(it) {};

MyClass._r = [0, ["IT"]];
MyClass.displayName = "MyClass";